import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../Interceptor/interceptor";


export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: baseApiQuery,
    tagTypes: ["posts"],
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (user) => ({
                url: 'wh/login/',
                method: 'POST',
                body: user,
            })
        }),
        register: builder.mutation({
            query: (user) => ({
                url: 'wh/customer/create/',
                method: 'POST',
                body: user,
            })
        }),
        changePassword: builder.mutation({
            query: (user) => ({
                url: 'wh/user/chgpass/',
                method: 'POST',
                body: user,
            })
        }),
        forgotPassword: builder.mutation({
            query: (user) => ({
                url: 'wh/user/forgotpassword/',
                method: 'POST',
                body: user,
            })
        }),
        resetPassword: builder.mutation({
            query: (user) => ({
                url: 'wh/user/resetpassword/',
                method: 'POST',
                body: user,
            })
        })
    })
})

export const { useLoginMutation, useRegisterMutation, useChangePasswordMutation, useForgotPasswordMutation, useResetPasswordMutation } = authApi